import { render, staticRenderFns } from "./MultipleRankingLists.vue?vue&type=template&id=3a533287&scoped=true&"
import script from "./MultipleRankingLists.vue?vue&type=script&lang=js&"
export * from "./MultipleRankingLists.vue?vue&type=script&lang=js&"
import style0 from "./MultipleRankingLists.vue?vue&type=style&index=0&id=3a533287&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a533287",
  null
  
)

export default component.exports